function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import { Feature } from 'ol';
import { WKT, GeoJSON, GPX } from 'ol/format';
import { Point, LineString, Polygon } from 'ol/geom';
import { fromExtent, circular } from 'ol/geom/Polygon';
import { Vector } from 'ol/source';
import { transform, transformExtent as olTransformExtent } from 'ol/proj';
import { getCenter, containsCoordinate } from 'ol/extent';
import { getDistance } from 'ol/sphere';
import { buffer } from 'ol/extent';
import { Icon } from 'ol/style.js';
var idCounter = 0;

/**
 * Id Counter, used to generate unique feature ids.
 */
function getId() {
  return idCounter++;
}

/**
 *
 * @param {string} wkt
 * @param {object} props
 */
function createFeatureFromWkt(wkt, props) {
  var f = new WKT().readFeature(wkt);
  f.setId(getId());
  if (props) {
    f.setProperties(props);
  }
  return f;
}

/**
 *
 * @param {ok.feature} feature
 */
function getWktFromFeature(feature, props) {
  return new WKT().writeFeature(feature, props);
}

/**
 *
 * @param {array} coords
 * @param {string} layout - Point, LineString, Polygon
 */
function createPoint(coords, layout) {
  return new Point(coords, layout);
}

/**
 *
 * @param {array} coords
 * @param {string} layout - Point, LineString, Polygon
 */
function createLineString(coords, layout) {
  return new LineString(coords, layout);
}

/**
 *
 * @param {array} coords
 * @param {string} layout - Point, LineString, Polygon
 */
function createPolygon(coords, layout) {
  return new Polygon(coords, layout);
}

/**
 *
 * @param {ol.Extent} extent
 */
function createPolygonFromExtent(extent) {
  return fromExtent(extent);
}
function createCircularPolygon(center, radius) {
  return circular(center, radius);
}

/**
 * @param {ol.Extent} extent
 * @param {value} number
 * @param {ol.Extent} opt_extent
 */
function bufferExtent(extent, value, opt_extent) {
  return buffer(extent, value, opt_extent);
}

/**
 *
 * @param {ol.geom} geom - ol.geom
 * @param {Object} props - Object with properties
 */
function createFeatureFromGeometry(geom, props) {
  var f = new Feature(_extends({}, props, {
    geometry: geom
  }));
  f.setId(getId());
  return f;
}

/**
 *
 * @param {ol.feature} feature - ol.Feature
 * @param {object} props - Object with properties
 */
function setFeatureProps(feature, props) {
  feature.setProperties(props);
}

/**
 * @param {ol.feature} feature - ol.feature
 * @param {string} propName - property name
 */
function getFeatureProp(feature, propName) {
  return feature.get(propName);
}

/**
 *
 * @param {Array<ol.feature>} features - Array of ol.feature
 */
function getExtentFromFeatures(features) {
  return new Vector({
    features: features
  }).getExtent();
}

/**
 * @param {ol.Coordinate}
 * @param { string | ol.ProjectionLike}
 * @param { string | ol.ProjectionLike}
 */
function transformCoordinate(coord, fromProjCode, toProjCode) {
  return transform(coord, fromProjCode, toProjCode);
}

/**
 * @param {ol.Extent}
 * @param { string | ol.ProjectionLike}
 * @param { string | ol.ProjectionLike}
 */
function transformExtent(extent, fromProjCode, toProjCode) {
  return olTransformExtent(extent, fromProjCode, toProjCode);
}

/**
 * @param {Document|Node|Object|String}
 * @param {Object}
 */
function readFeaturesFromGeoJson(source, options) {
  return new GeoJSON().readFeatures(source, options);
}

/**
 * @param {ol.Extent} extent
 * @param {ol.coord} coordinate
 */
function extentContainsCoordinate(extent, coordinate) {
  return containsCoordinate(extent, coordinate);
}

/**
 *
 * @param {ol.geom} geom
 */
function getCenterFromGeom(geom) {
  return getCenter(geom.getExtent());
}

/**
 *
 * @param {ol.coord} point1
 * @param {ol.coord} point2
 */
function calculateDistance(point1, point2) {
  return getDistance(point1, point2);
}

/**
 *
 * @param {string url} url
 */
function readFeaturesFromGpx(url, projection) {
  var features = new GPX().readFeatures(url, {
    featureProjection: projection
  });
  features.forEach(function (f) {
    return f.setId(getId());
  });
  return features;
}

/**
 *
 * @param {Object}
 */
function createOlIcon(iconProps) {
  return new Icon(iconProps);
}
export default {
  createFeatureFromWkt: createFeatureFromWkt,
  getWktFromFeature: getWktFromFeature,
  createFeatureFromGeometry: createFeatureFromGeometry,
  createPoint: createPoint,
  createLineString: createLineString,
  createPolygon: createPolygon,
  createPolygonFromExtent: createPolygonFromExtent,
  setFeatureProps: setFeatureProps,
  getFeatureProp: getFeatureProp,
  getExtentFromFeatures: getExtentFromFeatures,
  transformCoordinate: transformCoordinate,
  transformExtent: transformExtent,
  readFeaturesFromGeoJson: readFeaturesFromGeoJson,
  extentContainsCoordinate: extentContainsCoordinate,
  getCenterFromGeom: getCenterFromGeom,
  calculateDistance: calculateDistance,
  readFeaturesFromGpx: readFeaturesFromGpx,
  bufferExtent: bufferExtent,
  createOlIcon: createOlIcon,
  createCircularPolygon: createCircularPolygon
};